import { Card, Form, Input, Button, message } from "antd";
import md5 from 'js-md5';
import { useNavigate } from 'react-router-dom'
import './Login.scss'
import useStore from "../../store";
const Item = Form.Item;

function Login() {
  const navigate = useNavigate();
  const { LoginStore } = useStore();
  
  const onFinish = async (values) => {
    const { username, passwd } = values;
    try {
      if (username && username !== '' && passwd &&  passwd !== '') {
        let passwdMd5 = md5(md5(passwd + 'twy-service'));
        await LoginStore.getToken({ username, passwd: passwdMd5 });
        navigate('/layout/home', { replace: true });
        message.success('login success');
      } else {
        message.error('username or password error');
      }
    } catch (e) {
      message.error(e.response?.data.message || 'login faild');
    }
  }
  
  return (
    <div className="login">
      <Card className="login-container">
        <div className="login-title">TENWAYS</div>
        <Form onFinish={ onFinish }>
          <Item name="username">
            <Input size="large" placeholder="username"/>
          </Item>
          <Item name="passwd">
            <Input.Password size="large" placeholder="password"/>
          </Item>
          <Item>
            <Button type="primary" htmlType="submit" size="large">Login</Button>
          </Item>
        </Form>
      </Card>
    </div>
  )
}
export default Login;